<template>
  <div class="footer">
    <div class="product">
      <div class="product-cont">
        <div class="footer-menu">
          <div class="footer-menu-left">
            <img class="footer-logo" src="../../static/image/logo2.png" alt="">
          </div>
          <div class="footer-menu-right" v-if="menu">
            <ul>
              <li lass="menu-item" v-for="(item, index) in menu" :key="index" @click="getmenu(item, index)"
                v-if="item.meta.isShow">
                <p> {{item.meta.title}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-botom">
          <div class="footer-phone">{{ info.company_tel.desc || '' }}</div>
          <div class="footer-warrant">
            <div class="footer-warrant-left flex-space-between">
              <div class="footer-warrant-left-site ">
                <img class="site" src="../../static/image/footer-site.png" alt="">
                <p class="footer-warrant-left-conent">{{ info.company_address.desc || "" }}</p>
              </div>
              <div class="footer-warrant-tripartite">
                <ul>
                  <li  v-if="info.twitter && info.twitter.status == 'normal'">
                    <a target="blank" :href="info.twitter.url">
                      <img class="fg" src="../../static/image/footer-fg.png" alt="">
                    </a>
                  </li>
                  <li v-if="info.instagram && info.instagram.status == 'normal'">
                    <a target="blank" :href="info.instagram.url">
                      <img class="xj" src="../../static/image/footer-xj.png" alt="">
                    </a>
                  </li>
                  <li v-if="info.facebook && info.facebook.status == 'normal'">
                    <a target="blank" :href="info.facebook.url">
                      <img class="f" src="../../static/image/footer-f.png" alt="">
                    </a>
                  </li>
                  <li v-if="info.youtube && info.youtube.status == 'normal'">
                    <a target="blank" :href="info.youtube.url">
                      <img class="video" src="../../static/image/footer-video.png" alt="">
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="footer-warrant-right flex-space-between">
              <div class="footer-warrant-left-email">
                <img class="email" src="../../static/image/footer-email.png" alt="">
                <p class="footer-warrant-left-conent">{{ info.company_email.desc||'' }}</p>
              </div>
              <div class="footer-warrant-right-botoom">
                <ul>
                  <li  v-if="info.copyright && info.copyright.status == 'normal'">
                    <a target="blank" :href="info.copyright.url">{{ info.copyright.desc||'' }}
                    </a>
                  </li>
                  <li  v-if="info.beian_info && info.beian_info.status == 'normal'">
                    <a  target="blank" :href="info.beian_info.url">{{ info.beian_info.desc ||''}}
                    </a>
                  </li>
                  <li><a target="blank" href="https://www.allwww.cn">Made in Allwww <易网></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {},
    };
  },
  watch: {
    // $route() {
    //   // this.menuIndex = this.$router.history.current.meta.name
    // },
  },
  created() {
    this.menu = this.$router.history.router.options.routes;
    this.info = JSON.parse(localStorage.getItem("info")) || {}
  },
  mounted() {
   
  },
  methods: {
    getmenu(item, index) {
      this.$router.push({ name: item.name })
    },
  }
};
</script>
<style lang="scss" scoped>
.footer {
  background-image: url("../../static/image/footer-bg.png");
  width: 100%;
}

.footer-menu {
  padding: 38px 0 26px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba($color: #ffff, $alpha: 0.3);
}

.footer-menu-left {
  .footer-logo {
    // width: 62.86px;
    // height: 59px;
  }
}

.footer-menu-right {
  font-size: 18px;

  color: #ffffff;

  ul {
    height: 100% !important;
  }

  li {
    margin-right: 64px;
    cursor: pointer;
  }
}

.footer-botom {
  padding: 32px 0 58px 0;

  .footer-phone {
    font-size: 36px;
    font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: #ffffff;
  }

  .footer-warrant {
    margin-top: 22px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba($color: #ffffff, $alpha: 0.5);
  }

  .footer-warrant-left {
    .footer-warrant-left-site {
      max-width: 450px;
      display: flex;
      align-items: self-start;

      .site {
        width: 19px;
        height: 19px;
      }
    }

    .footer-warrant-tripartite {
      li {
        margin-right: 32px;
      }

      .fg {
        width: 30.34px;
        height: 24.65px;
      }

      .xj {
        width: 25.61px;
        height: 25.61px;
      }

      .f {
        width: 23.57px;
        height: 23.57px;
      }

      .video {
        width: 30.77px;
        height: 21.56px;
      }
    }
  }

  .footer-warrant-right {
    margin-top: 16px;

    .footer-warrant-right-botoom {
      li {
        margin-right: 25px;
      }
    }

    .footer-warrant-left-email {
      display: flex;
      align-items: self-start;
      max-width: 450px;

      .email {
        width: 15.28px;
        height: 12.5px;
      }
    }
  }
}

.footer-warrant-left-conent {
  margin-left: 17px;
}

li:last-child {
  margin-right: 0 !important;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 767px) {
  // .footer {
  //   display: none;
  // }
  .footer-menu {
    display: block;
  }
  .footer-menu-right {
    display: none;
  }
  .footer-botom{
    padding: 32px 0 28px 0;
  }
  .flex-space-between {
    display: block;
  }
  .footer-warrant-tripartite {
    display: none;
  }
  .footer-menu-left{
    img{
      height: 40px;
    }
  }
  .footer-phone{
    font-size: 26px !important;
  }
  .footer-warrant-right-botoom {
    ul {
      margin-block-start: 0;
      margin-block-end: 0;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 0;
      display: block;
    }
    li {
      margin-top: 15px;
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue